import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { StyledPageWrapper, Title } from "@monorepo/components";
import { PERLAS_GO_CAR_INSURANCE, PERLAS_GO_INSURANCE } from "@monorepo/constants";
import theme from "@monorepo/styles/theme";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CarInsuranceBlob from "assets/blobs/CarInsuranceBlob";

import { PageWrapper, ServicesLink, ServicesList } from "components/Services/ServicesPage";

const CarInsuranceService: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledPageWrapper>
      <PageWrapper>
        <Title>{t("services.security")}</Title>
        <CarInsuranceBlob />
        <Typography textAlign="justify">{t("car_insurance.first_p")}</Typography>
        <Typography component="h2" sx={{ justifySelf: "flex-start" }}>
          <Trans i18nKey="car_insurance.first_ul_title" components={[<strong />]} />
        </Typography>
        <ServicesList>
          <Typography component="li">{t("car_insurance.first_ul_first_li")}</Typography>
          <Typography component="li">{t("car_insurance.first_ul_second_li")}</Typography>
          <Typography component="li">
            {t("car_insurance.first_ul_third_li")}
            <ServicesLink sx={{ color: theme.palette.primary.main }} target={"_blank"} href={PERLAS_GO_INSURANCE}>
              www.perlodraudimas.lt
            </ServicesLink>
          </Typography>
        </ServicesList>
        <ServicesLink href={PERLAS_GO_CAR_INSURANCE} target="_blank">
          <Button
            sx={{ padding: theme.spacing(2, 5), textTransform: "capitalize", width: { xs: "100%", sm: "auto" } }}
            variant="outlined"
          >
            <Typography sx={{ textDecoration: "none" }} textAlign="center" variant="subtitle2" component="span">
              {t("common.learn_more")}
            </Typography>
          </Button>
        </ServicesLink>
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default CarInsuranceService;
